import ClientTemplate from "components/layout/templates/clientTemplate";
import { FC, useState } from "react";
import { Breadcrumb, BreadcrumbItem, Panel, Tab, Tabs } from "@appkit4/react-components";
import ClientView from "./clientView";
import UserView from "../client/components/user/userView";
import { useNavigate } from "react-router-dom";
import { UserLevel } from "routes/analysis/types/analysis";
import { useCookies } from "react-cookie";
import { decodeToken } from "services/common";

const Administration: FC<{ index?: number }> = ({ index = 0 }) => {
  const [activeIndex, setActiveIndex] = useState(index);
  const [cookie] = useCookies();
  const navigate = useNavigate();

  const checkUserLevel = (level: UserLevel) => {
    const jwtData = decodeToken(cookie["id_token"]);
    return jwtData?.userLevel && UserLevel[jwtData.userLevel as keyof typeof UserLevel] <= level;
  }

  const getPage = (index: number) => {
    switch(index)
    {
      case 0:
        return <ClientView />
      case 1:
        return <UserView />
    }
  }
  const handleTabChange = (index: number) => {
    switch(index)
    {
      case 0:
        navigate("/administration");
        setActiveIndex(0);
        break;
      case 1:
        navigate("/administration/users");
        setActiveIndex(1);
        break;
    }
  }
  return (
    <ClientTemplate>
      <Breadcrumb>
        <BreadcrumbItem>Administration</BreadcrumbItem>
        <BreadcrumbItem>{index === 0 ? "Clients" : "Users"}</BreadcrumbItem>
      </Breadcrumb>
      <div className="mt-6"
      >
          <Tabs activeIndex={activeIndex} onTabChange={handleTabChange}>
            <Tab label="Clients" value="0"></Tab>
            <Tab label="Users" value="1" disabled={!checkUserLevel(UserLevel.PwCAdmin)}></Tab>
          </Tabs>
          <Panel>
          {
            getPage(activeIndex)
          }
          </Panel>
      </div>
      </ClientTemplate>
  )
}


export default Administration;